import script from "./BtnElm.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnElm.vue?vue&type=script&setup=true&lang=js"

import "./BtnElm.vue?vue&type=style&index=0&id=3a1b95c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a1b95c2"]])

export default __exports__